import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import SettlementsBasicInfoComponent from "./settlement-requests-basic-info.component";

export const SettlementPopup = ({ 
  selectedSettlement,
  closeModal,
  handleSaveSettlement,
}: any) => {
  console.log('selectedSettlement', selectedSettlement)
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedSettlement));

    const handleLocalFormChange = ({path, value}: any) => {
      // setLocalAttribute(prev => ({
      //   ...prev,
      //   [field]: value,
      // }));
      console.log('selectedSettlement, path, value', selectedSettlement, path, value)
      const updatedData = updateNestedValue(selectedSettlement, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      // setSelectedProductSpecificationAttributeItem(localAttribute);
      handleSaveSettlement(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <SettlementsBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedSettlement={selectedSettlement}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }